import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./Source";
import { Fetch } from "../../shared/Fetch";

export interface IEmptySource {
    sourceId?: number,
    source_Name?: string,
    createdOn?: Date,
    user_Added_By?: number,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptySource = {
    source_Name: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmptySource>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>: ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Source</h5>
        </div>
    );

    const loadTableData = async ()=>{
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Source_Mast", "GET", null, null, props.toast);
        if(response){
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew=()=>{
        props.setModal({ open: true, singleData: EmptySource });
    };
    const openEdit=(rowData: IEmptySource)=>{
        props.setModal({ open: true, singleData: rowData });
    };
    const action=(rowData: IEmptySource)=>{
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={()=>openEdit(rowData)}></Button>
            </div>
        );
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="source_Name" header="Source Name"/>
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
            </DataTable>
        </>
    );
}